/** 设置 -> 规划：工作流程区块（规划第三阶段，计划 P3-3b D-161）。展开到 settings-zh.ts。 */
export default {
  title: '征询、编号与条件',
  intro: '供 KM 程序使用：案件征询的机构、决定函的编号方式、地方政府代码、地方规划以及条件库。',
  agencies: '征询机构',
  agenciesHint: '市议会部门通过其群组在 gisify 中回复；外部机构的回复由 OSC 单位录入。',
  agencyRow: '机构 {{index}}',
  agencyCode: '代码',
  agencyKind: '类型',
  agencyNameIn: '名称（{{locale}}）',
  agencyGroup: '部门群组',
  noGroup: '尚无群组',
  addAgency: '添加机构',
  remove: '移除',
  numbering: '决定编号',
  numberingHint: '在流水号的位置写 {seq}（{seq:4} 补足为四位数），如需年份可写 {yyyy} 或 {yy}。',
  preview: '下一个编号将类似 {{example}}。',
  schemes: {
    borang_c1: 'C1 表格（规划许可）',
    kelulusan_bangunan: '建筑图批准',
  },
  pbtId: '地方政府代码（PBT）',
  pbtIdHint: '全国导出为此地方政府使用的代码：字母、数字、连字符和下划线，最多 32 个。',
  localPlanInForce: '地方规划已生效',
  localPlanInForceHint: '若无地方规划，KM 案件在提交建议前须向邻居发出通知。登记时以此答案为起点。',
  library: '条件库',
  libraryHint: '官员可一步加入决定的条件。',
  conditionRow: '条件 {{index}}',
  libraryCode: '代码',
  libraryPCode: '遵守阶段',
  libraryText: '条件',
  addCondition: '添加条件',
  choose: '请选择…',
  errors: {
    agencyCode: '请使用小写字母、数字、连字符或下划线，以字母或数字开头，最多 40 个。',
    agencyRepeated: '另一个机构已使用此代码。',
    agencyLabel: '请至少用一种语言填写名称，每个最多 200 个字符。',
    externalGroup: '外部机构没有部门群组。',
    agenciesMax: '最多 {{max}} 个机构。',
    pbtId: '请使用字母、数字、连字符或下划线，最多 32 个。',
    libraryCode: '以字母或数字开头，其后为字母、数字、句点、括号、连字符或下划线，最多 64 个。',
    libraryRepeated: '另一项条件已使用此代码。',
    libraryPCode: '请填写遵守阶段。',
    libraryText: '请填写条件内容，最多 2000 个字符。',
    libraryTextCharacters: '请删除条件中隐藏的控制字符（例如粘贴进来的换行符）。',
    libraryMax: '最多 {{max}} 项条件。',
  },
  formatIssues: {
    empty: '请填写格式。',
    too_long: '过长：编号不得超过 64 个字符。',
    unsafe: '请删除控制字符。',
    spaces: '请删除开头或结尾的空格。',
    no_sequence: '请添加 {seq} 或 {seq:N} 作为流水号。',
    two_sequences: '流水号只能使用一次。',
    stray_brace: '花括号只能用于 {seq}、{seq:N}、{yyyy} 和 {yy}。',
  },
} as const
